import React, { useState } from "react";
import { Box } from "@mui/material";
import { MapContainer, TileLayer, Polygon } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import PageHeader from "../components/PageHeader";

// Beispielhafte Koordinaten für die Reviergrenze (Polygon)
const revierGrenze = [
  [51.123, 10.123],
  [51.124, 10.128],
  [51.127, 10.127],
  [51.126, 10.121],
  [51.123, 10.123]
];

// Beispielhafte SVG-Flächen (Feld, Wiese, Weide)
const flaechen = [
  {
    id: "feld1",
    name: "Feld 1",
    farbe: "#ffe082",
    coords: [
      [51.124, 10.124],
      [51.125, 10.126],
      [51.126, 10.124],
      [51.125, 10.122]
    ]
  },
  {
    id: "wiese1",
    name: "Wiese 1",
    farbe: "#a5d6a7",
    coords: [
      [51.125, 10.127],
      [51.126, 10.129],
      [51.127, 10.128],
      [51.126, 10.126]
    ]
  },
  {
    id: "weide1",
    name: "Weide 1",
    farbe: "#b3e5fc",
    coords: [
      [51.124, 10.120],
      [51.125, 10.121],
      [51.126, 10.120],
      [51.125, 10.119]
    ]
  }
];

export default function Revierkarte() {
  const [selected, setSelected] = useState(null);

  // Klick-Handler für Flächen
  const handlePolygonClick = (id) => {
    setSelected(id);
  };

  return (
    <Box>
      <PageHeader title="Revierkarte" />
      <Box sx={{ position: "relative", height: "calc(100vh - 7.5rem)", minHeight: 400, width: "100%" }}>
        <MapContainer
          center={[51.125, 10.124]}
          zoom={15}
          style={{ height: "100%", width: "100%" }}
        >
          <TileLayer
            attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

        {/* Reviergrenze */}
          <Polygon
            positions={revierGrenze}
            pathOptions={{ color: "red", weight: 3, fillOpacity: 0.05 }}
          />

        {/* SVG-Flächen */}
          {flaechen.map((flaeche) => (
            <Polygon
              key={flaeche.id}
              positions={flaeche.coords}
              pathOptions={{
                color: selected === flaeche.id ? "blue" : "gray",
                fillColor: flaeche.farbe,
                fillOpacity: 0.5,
                weight: selected === flaeche.id ? 4 : 2
              }}
              eventHandlers={{
                click: () => handlePolygonClick(flaeche.id)
              }}
            />
          ))}
        </MapContainer>
        {selected && (
          <Box sx={{
            position: "absolute",
            top: 20,
            left: 20,
            background: "#fff",
            p: 1.25,
            borderRadius: 1,
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
          }}>
            <b>Ausgewählt:</b> {flaechen.find(f => f.id === selected)?.name}
          </Box>
        )}
      </Box>
    </Box>
  );
}
